import { HttpEvent, HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { Observable } from 'rxjs';

import { CookiesUtils } from '../utils';

export function kwankoAwinInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  if (req.url.match(/(.*)\/orders[^/].*/g)) {
    const s2sActivation = CookiesUtils.getCookie('s2s_activation');
    const tcPrivacy = CookiesUtils.getCookie('TC_PRIVACY');

    if (s2sActivation !== '' && tcPrivacy !== '') {
      req = req.clone({
        setParams: {
          s2s_activation: s2sActivation,
          tc_privacy: tcPrivacy
        }
      });
    }
  }
  return next(req);
}
